import { create } from 'zustand';
import type { BreathworkConfiguration, JourneyStepTechnique } from '@breath-lab/types';
import type { SessionGrant } from '@breath-lab/domain';

export interface JourneyContext {
  userJourneyDocId: string;
  journeyId: string;
  stepId: string;
  stepIndex: number;
  totalSteps: number;
  stepTitle: string;
  techniques: JourneyStepTechnique[];
  techniqueIndex: number;
}

interface PendingSessionState {
  breathworkId: string | null;
  config: BreathworkConfiguration | null;
  sessionToken: SessionGrant | null;
  journeyContext: JourneyContext | null;
  preFeelingIds: string[] | null;

  setPendingSession(
    breathworkId: string,
    config: BreathworkConfiguration,
    sessionToken: SessionGrant | null,
    journeyContext?: JourneyContext | null,
  ): void;
  setPreFeelingIds(ids: string[]): void;
  clearPendingSession(): void;
}

export const usePendingSession = create<PendingSessionState>((set) => ({
  breathworkId: null,
  config: null,
  sessionToken: null,
  journeyContext: null,
  preFeelingIds: null,

  setPendingSession(breathworkId, config, sessionToken, journeyContext = null) {
    set({ breathworkId, config, sessionToken, journeyContext, preFeelingIds: null });
  },

  setPreFeelingIds(ids) {
    set({ preFeelingIds: ids });
  },

  clearPendingSession() {
    set({ breathworkId: null, config: null, sessionToken: null, journeyContext: null, preFeelingIds: null });
  },
}));
